import ContactForm from '../components/ContactForm';

export default {
  init() {
    // JavaScript to be fired on the label page

    // window.addEventListener('load', () => {
    new ContactForm(document.getElementById('contact-form'));
    // });
  },
  finalize() {
    // JavaScript to be fired on the label page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js